import { isTooManyRequestsError, isUnauthenticatedError } from "util/error-tracking";

const EXPIRED_SESSION_MESSAGE =
    "Your session has expired. Please sign in again to continue.";
const LOCKOUT_FALLBACK_MESSAGE =
    "Too many failed attempts. Please wait a few minutes before trying again or contact support for help.";
const GENERIC_RETRY_MESSAGE =
    "Failed to send two-factor code. Refresh and try again. If you continue to have trouble, please contact support.";

const serverErrorMessage = (error: unknown): string | null => {
    if (!error || typeof error !== "object") {
        return null;
    }
    const response = (error as { response?: { data?: { err?: unknown } } }).response;
    const err = response?.data?.err;
    return typeof err === "string" && err.length > 0 ? err : null;
};

export const sendCodeFailureMessage = (error: unknown): string => {
    if (isUnauthenticatedError(error)) {
        return EXPIRED_SESSION_MESSAGE;
    }
    if (isTooManyRequestsError(error)) {
        return serverErrorMessage(error) ?? LOCKOUT_FALLBACK_MESSAGE;
    }
    return GENERIC_RETRY_MESSAGE;
};
